import React, { useState, useRef, useEffect } from 'react';

const Tooltip = ({ data, field, children }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const triggerRef = useRef(null);

    const updatePosition = () => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setPosition({
                x: rect.left + (rect.width / 2),
                y: rect.bottom + window.scrollY
            });
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', updatePosition);
        window.addEventListener('resize', updatePosition);
        return () => {
            window.removeEventListener('scroll', updatePosition);
            window.removeEventListener('resize', updatePosition);
        };
    }, []);

    return (
        <div className="relative inline-block group cursor-help" ref={triggerRef} onMouseEnter={updatePosition}>
            {children}
            <div className="fixed hidden group-hover:block" style={{ 
                left: `${position.x}px`,
                top: `${position.y}px`,
                transform: 'translateX(-50%)',
                zIndex: 9999
            }}>
                <span
                    className="block bg-primary text-white text-sm rounded-lg px-4 py-3 w-72 mt-2 shadow-lg"
                    dangerouslySetInnerHTML={{ 
                        __html: data[field]?.replace(/\n/g, '<br>')
                            .replace(/<ul>/g, '<ul class="list-disc pl-4 mt-2">')
                            .replace(/<li>/g, '<li class="mb-1">')
                            .replace(/<p>/g, '<p class="mb-2">')
                    }}
                />
                <div className="absolute w-3 h-3 bg-primary transform rotate-45 left-1/2 -translate-x-1/2 -top-1.5"></div>
            </div>
        </div>
    );
};

export default Tooltip;
